export const Header = [{
  prop: 'LABROOM_NAME',
  label: '实验室名称'
}, {
  prop: 'LABROOM_NO',
  label: '房间编号'
}, {
  prop: 'PERSON_NAME',
  label: '负责人'
}, {
    prop: 'PERSON_PHONE',
    label: '负责人电话'
}]

